import React from 'react'
import styled from 'styled-components'
import { Rocket } from 'svg'
import theme from '../../../../themes/light'

const Wrapper = styled.div`
  position: relative;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadow};
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  flex: 1 1 auto;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 7.5rem;
  margin-bottom: 2rem;
`

const RocketContainer = styled.div`
  position: absolute;
  bottom: calc(100% - 13px);
  left: 0;
  right: 0;
`

const Title = styled.h3`
  color: ${theme.titleColor};
  font: ${theme.fonts.header};
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  padding-bottom: 1rem;
`

const Message = styled.p`
  margin-top: auto;
  margin-bottom: auto;
  color: ${theme.colors.gray60};
  font: ${theme.fonts.small};
  text-align: center;
  width: 90%;
`

const Subscribe = () => (
  <Wrapper>
    <RocketContainer>
      <Rocket />
    </RocketContainer>
    <Title>You have no active Interseller subscription</Title>
    <Message>If you've been a subscriber before, reach out to your customer representative about resubscribing.</Message>
  </Wrapper>
)

export default Subscribe
